export default function Iframe({ iframe_url, title }) {
  return (
    <section className="flex flex-col max-w-7xl mx-auto p-4 my-12">
      <div className="map-responsive">
        <iframe
          src={iframe_url}
          width="600"
          height="450"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={title}
        />
      </div>
    </section>
  );
}
